"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _util = require("../util");

var _campaignPack = require("./campaignPack");

var _campaignPack2 = _interopRequireDefault(_campaignPack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CampaignsProduct = function () {
  function CampaignsProduct(data) {
    var _this = this;

    (0, _classCallCheck3.default)(this, CampaignsProduct);

    this.data = data;
    this.giftPacks = [];
    this.data.giftPacks.forEach(function (g) {
      g.each = _this.data.each;
      g.sectionId = _this.data.sectionId;
      g._allFromStore = _this.data._allFromStore;
      g.cid = _this.data.cid;
      var pakc = (0, _util.create)(_campaignPack2.default, g);
      _this.giftPacks.push(pakc);
    });
  }

  (0, _createClass3.default)(CampaignsProduct, [{
    key: "packcount",
    value: function packcount() {
      var currentCount = 0;
      this.giftPacks.forEach(function (g) {
        currentCount += g.data.times;
      });
      return currentCount;
    }
  }, {
    key: "setCanAdd",
    value: function setCanAdd(surplus) {
      // let each = this.data.each
      // console.log(surplus)
      // console.log(surplus, this.giftPacks)
      this.giftPacks.forEach(function (g) {
        if (surplus > 0 && !g.data.sellOut) {
          g.data._canAdd = true;
        } else {
          g.data._canAdd = false;
        }
        // if(surplus <= 0){
        //   g._canAdd = false
        // }
        // if(each > surplus){
        //   g._canAdd = false
        // }else{
        //   g._canAdd = true
        // }
      });
    }

    // setInWarehousePack(s) {
    //   this.giftPacks.forEach(g => {
    //     g.setInWarehousePack(s)
    //   })
    // }

  }]);
  return CampaignsProduct;
}();

exports.default = CampaignsProduct;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/ipos/campaignProduct.js
// module id = 1158
// module chunks = 0